var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'fill-height' : true, 'box' : _vm.buttons}},_vm._l((_vm.components),function(comp,key){return _c(comp,{key:key,tag:"component",class:{'ma-1' : _vm.buttons}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }